import React, { useState } from 'react';
import { Navbar, Container } from 'react-bootstrap';
import logo from '../../../assets/images/Capa_1.png';
import NosotrosDropdown from './NosotrosDropdown';
import ProductosDropdown from './ProductosDropdown';
import MedicosDropdown from './MedicosDropdown';
import ProductoCard from '../../../features/catalogo/components/ProductoCard';
import Trabajo from '../../modals/Trabajo';
import '../../../layouts/BioMercy.css';

const NavbarBioMercy = ({
  onVerCatalogo,
  onVerQuienesSomos,
  onVerMedicos,
  onCerrarCatalogo,
  onAbrirRegistro,
}) => {
  const [activeLink, setActiveLink] = useState('');
  const [showNosotrosDropdown, setShowNosotrosDropdown] = useState(false);
  const [showProductosDropdown, setShowProductosDropdown] = useState(false);
  const [showMedicosDropdown, setShowMedicosDropdown] = useState(false);
  const [activeNosotrosTab, setActiveNosotrosTab] = useState('');
  const [activeProductosTab, setActiveProductosTab] = useState('');
  const [activeMedicosTab, setActiveMedicosTab] = useState('');
  const [productoSeleccionadoNombre, setProductoSeleccionadoNombre] =
    useState(null);
  const [showTrabajoModal, setShowTrabajoModal] = useState(false);

  const handleNavClick = (link, e) => {
    e.preventDefault();

    if (link === '#nosotros') {
      setShowNosotrosDropdown(prev => !prev);
      setShowProductosDropdown(false);
      setShowMedicosDropdown(false);
      setActiveLink(link);
    } else if (link === '#productos') {
      setShowProductosDropdown(prev => !prev);
      setShowNosotrosDropdown(false);
      setShowMedicosDropdown(false);
      setActiveLink(link);
    } else if (link === '#medicos') {
      setShowMedicosDropdown(prev => !prev);
      setShowNosotrosDropdown(false);
      setShowProductosDropdown(false);
      setActiveLink(link);
    } else if (link === '#noticias') {
      // 👉 Disparar scroll a "Últimas noticias"
      onVerMedicos('noticias');
      setShowNosotrosDropdown(false);
      setShowProductosDropdown(false);
      setShowMedicosDropdown(false);
      setActiveLink('');
    } else {
      setShowNosotrosDropdown(false);
      setShowProductosDropdown(false);
      setShowMedicosDropdown(false);
      setActiveLink(link);

      switch (link) {
        case '#trabaja':
          setShowTrabajoModal(true);
          break;
        case '#inicio':
          onCerrarCatalogo();
          setActiveLink('');
          window.scrollTo({ top: 0, behavior: 'smooth' });
          break;
        default:
          break;
      }
    }
  };

  const handleNosotrosTabClick = tab => {
    setActiveNosotrosTab(tab);
    setShowNosotrosDropdown(false);
    setActiveLink('');
    onVerQuienesSomos(tab);
  };

  const handleProductosVerCatalogo = () => {
    setShowProductosDropdown(false);
    setActiveLink('');
    onVerCatalogo();
  };

  const handleMedicosTabClick = tab => {
    setActiveMedicosTab(tab);
    setShowMedicosDropdown(false);
    setActiveLink('');
    onVerMedicos(tab);
  };

  const handleSeleccionarProducto = nombreProducto => {
    setProductoSeleccionadoNombre(nombreProducto);
    setShowProductosDropdown(false);
    setActiveLink('');
  };

  const handleCloseProductoModal = () => {
    setProductoSeleccionadoNombre(null);
  };

  return (
    <>
      <Navbar expand="lg" className="navbar-biomercy">
        <Container fluid className="px-4 position-relative">
          <div className="nav-central-container">
            <div className="nav-item-group left-group">
              <div
                className="nav-central-item"
                onClick={e => handleNavClick('#nosotros', e)}
              >
                <span className="nav-plus">+</span>
                <div>
                  <div
                    className={`nav-title ${activeLink === '#nosotros' ? 'active' : ''}`}
                  >
                    Nosotros
                  </div>
                  <div className="nav-subtitle">Nuestro equipo</div>
                </div>
              </div>

              <div
                className="nav-central-item"
                onClick={e => handleNavClick('#productos', e)}
              >
                <span className="nav-plus">+</span>
                <div>
                  <div
                    className={`nav-title ${activeLink === '#productos' ? 'active' : ''}`}
                  >
                    Productos
                  </div>
                  <div className="nav-subtitle">Nuestro catálogo</div>
                </div>
              </div>
            </div>

            <div
              className="nav-logo-center"
              onClick={e => handleNavClick('#inicio', e)}
              style={{ cursor: 'pointer' }}
            >
              <img src={logo} alt="BioMercy Logo" className="navbar-logo" />
            </div>

            <div className="nav-item-group right-group">
              <div
                className="nav-central-item"
                onClick={e => handleNavClick('#medicos', e)}
              >
                <span className="nav-plus">+</span>
                <div>
                  <div
                    className={`nav-title ${activeLink === '#medicos' ? 'active' : ''}`}
                  >
                    Médicos
                  </div>
                  <div className="nav-subtitle">al día</div>
                </div>
              </div>

              <div
                className="nav-central-item"
                onClick={e => handleNavClick('#trabaja', e)}
              >
                <span className="nav-plus">+</span>
                <div>
                  <div
                    className={`nav-title ${activeLink === '#trabaja' ? 'active' : ''}`}
                  >
                    Únete a
                  </div>
                  <div className="nav-subtitle">nuestro equipo</div>
                </div>
              </div>
            </div>
          </div>

          {/* Dropdowns */}
          <NosotrosDropdown
            visible={showNosotrosDropdown}
            activeTab={activeNosotrosTab}
            onTabClick={handleNosotrosTabClick}
          />

          <ProductosDropdown
            visible={showProductosDropdown}
            activeTab={activeProductosTab}
            setActiveTab={setActiveProductosTab}
            onVerCatalogo={handleProductosVerCatalogo}
            onSeleccionarProducto={handleSeleccionarProducto}
          />

          <MedicosDropdown
            visible={showMedicosDropdown}
            activeTab={activeMedicosTab}
            onTabClick={handleMedicosTabClick}
          />
        </Container>
      </Navbar>

      {/* Modal de producto */}
      {productoSeleccionadoNombre && (
        <div className="modal-overlay" onClick={handleCloseProductoModal}>
          <div className="modal-wrapper" onClick={e => e.stopPropagation()}>
            <ProductoCard
              productoNombre={productoSeleccionadoNombre}
              onClose={handleCloseProductoModal}
            />
          </div>
        </div>
      )}

      {/* Modal de "Trabaja con Nosotros" */}
      {showTrabajoModal && (
        <Trabajo
          isOpen={showTrabajoModal}
          onClose={() => setShowTrabajoModal(false)}
        />
      )}
    </>
  );
};

export default NavbarBioMercy;
